// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thumbnail-grid[data-v-abc53ef4]{margin:1em 0;padding:0;list-style:none;display:grid;grid:auto-flow/repeat(auto-fit,minmax(200px,1fr));align-items:center;grid-gap:1em;gap:1em}.thumbnail-grid li[data-v-abc53ef4]{padding:10px;text-align:center;border:1px solid #e8e8e8;background:#f4f4f4}.thumbnail-grid li img[data-v-abc53ef4]{max-width:100%}", ""]);
// Exports
module.exports = exports;
